import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=44a39bf2&scoped=true&"
import script from "./BugReport.vue?vue&type=script&lang=js&"
export * from "./BugReport.vue?vue&type=script&lang=js&"
import style0 from "./BugReport.vue?vue&type=style&index=0&id=44a39bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a39bf2",
  null
  
)

export default component.exports